require('./lbaDupeHotel.scss');

const lbaDupeHotel = angular.module('app.lbaDupeHotel', []);

lbaDupeHotel.component('lbaDupeHotel', {
  bindings: {},
  controllerAs: 'vm',
  controller: ['hotelsService', controller],
  template: require('./lbaDupeHotel.html')
});

function controller(hotelsService) {
  let vm = this;

  vm.blobUrl = blobUrl;
  vm.minimised = false;
  vm.hotelsService = hotelsService;
  vm.clear = clear;
  vm.makeMaster = makeMaster;
  vm.merge = merge;
  vm.minimise = minimise;
  vm.removeHotel = removeHotel;
  
  function clear() {
    hotelsService.clearAll();
    vm.minimised = false;
  }
  
  function makeMaster(hotel, index) {
    hotelsService.swapMaster(hotel, index);
  } 
  
  function merge() {
    hotelsService.merge();
  }
  
  function minimise() {
    vm.minimised = !vm.minimised;
  }
  
  function removeHotel(index) {
    hotelsService.removeHotel(index);
  }
  
  

}

export default lbaDupeHotel;


// WEBPACK FOOTER //
// ./src/components/lbaDupeHotel/lbaDupeHotel.js